webpackJsonp([168567824813152],{

/***/ 109:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyImage = __webpack_require__(12);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _arrowButton = __webpack_require__(19);
	
	var _arrowButton2 = _interopRequireDefault(_arrowButton);
	
	var _mediaQueries = __webpack_require__(8);
	
	var _MDText = __webpack_require__(25);
	
	var _MDText2 = _interopRequireDefault(_MDText);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GraphicCard = function GraphicCard(_ref) {
	  var title = _ref.title,
	      image = _ref.image,
	      imageStyle = _ref.imageStyle,
	      text = _ref.text,
	      route = _ref.route,
	      children = _ref.children,
	      style = _ref.style,
	      _ref$scale = _ref.scale,
	      scale = _ref$scale === undefined ? true : _ref$scale;
	  return scale ? _react2.default.createElement(
	    'div',
	    { className: 'card' },
	    _react2.default.createElement(
	      _mediaQueries.Default,
	      null,
	      _react2.default.createElement(
	        'div',
	        {
	          style: _extends({}, cardStyle, {
	            padding: '1.5rem 1.5rem 1rem 1.5rem',
	            display: 'flex',
	            flexDirection: 'row',
	            fontSize: '13px',
	            lineHeight: 1.35
	          }, style)
	        },
	        image && _react2.default.createElement(_gatsbyImage2.default, { sizes: image.sizes, style: _extends({}, imgStyle, imageStyle) }),
	        _react2.default.createElement(
	          'div',
	          { style: { marginLeft: '1em', fontWeight: 300 } },
	          _react2.default.createElement(
	            'div',
	            { style: _extends({}, titleStyle, { fontSize: '15px' }) },
	            title
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_MDText2.default, { source: text })
	          ),
	          children,
	          route && _react2.default.createElement(_arrowButton2.default, {
	            route: route,
	            style: { paddingTop: '1rem', marginBottom: 0 },
	            text: 'More'
	          })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _mediaQueries.Mobile,
	      null,
	      _react2.default.createElement(
	        'div',
	        { style: _extends({}, cardStyle, style) },
	        image && _react2.default.createElement(_gatsbyImage2.default, { sizes: image.sizes, style: _extends({}, imgStyle, imageStyle) }),
	        _react2.default.createElement(
	          'div',
	          { style: titleStyle },
	          title
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: textStyle },
	          _react2.default.createElement(_MDText2.default, { source: text })
	        ),
	        children,
	        route && _react2.default.createElement(_arrowButton2.default, {
	          route: route,
	          style: { paddingTop: '1rem' },
	          text: 'More'
	        })
	      )
	    )
	  ) : _react2.default.createElement(
	    'div',
	    { className: 'card', style: _extends({}, cardStyle, style) },
	    image && _react2.default.createElement(_gatsbyImage2.default, { sizes: image.sizes, style: _extends({}, imgStyle, imageStyle) }),
	    _react2.default.createElement(
	      'div',
	      { style: titleStyle },
	      title
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: textStyle },
	      _react2.default.createElement(_MDText2.default, { source: text })
	    ),
	    children,
	    route && _react2.default.createElement(_arrowButton2.default, { route: route, style: { paddingTop: '1rem' }, text: 'More' })
	  );
	};
	
	exports.default = GraphicCard;
	
	
	var cardStyle = {
	  fontFamily: '"Libre Franklin", "sans serif"',
	  padding: '2rem',
	  background: 'white'
	};
	
	var titleStyle = {
	  fontSize: '16px',
	  fontWeight: 'bold',
	  marginBottom: '.75rem',
	  textAlign: 'left'
	};
	
	var textStyle = {
	  fontSize: '14px',
	  fontWeight: 300
	};
	
	var imgStyle = {
	  height: '80px',
	  width: '80px',
	  marginLeft: '-.75rem',
	  marginTop: '-.75rem',
	  marginBottom: '1rem'
	};
	module.exports = exports['default'];

/***/ }),

/***/ 292:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.TuitionAndScholarshipsQuery = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _get2 = __webpack_require__(17);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _infoBlock = __webpack_require__(10);
	
	var _infoBlock2 = _interopRequireDefault(_infoBlock);
	
	var _collapsable = __webpack_require__(39);
	
	var _collapsable2 = _interopRequireDefault(_collapsable);
	
	var _angleBracketButton = __webpack_require__(13);
	
	var _angleBracketButton2 = _interopRequireDefault(_angleBracketButton);
	
	var _mediaQueries = __webpack_require__(8);
	
	var _graphicCard = __webpack_require__(109);
	
	var _graphicCard2 = _interopRequireDefault(_graphicCard);
	
	var _reactHelmet = __webpack_require__(24);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _sideContainer = __webpack_require__(73);
	
	var _sideContainer2 = _interopRequireDefault(_sideContainer);
	
	var _title = __webpack_require__(40);
	
	var _title2 = _interopRequireDefault(_title);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ScholarshipsPage = function (_Component) {
	  _inherits(ScholarshipsPage, _Component);
	
	  function ScholarshipsPage() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ScholarshipsPage);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      isNarrowDesktop: (0, _mediaQueries.isNarrowDesktop)(),
	      sideContainerHeight: 0
	    }, _this.handleResize = function () {
	      if (_this.state.isNarrowDesktop !== (0, _mediaQueries.isNarrowDesktop)()) {
	        _this.setState({ isNarrowDesktop: (0, _mediaQueries.isNarrowDesktop)() });
	      }
	      _this.setState({ sideContainerHeight: _this.getHeight() });
	    }, _this.getHeight = function () {
	      if (document && document.body) {
	        return document.body.scrollHeight - 45 - 210;
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  ScholarshipsPage.prototype.componentDidMount = function componentDidMount() {
	    if (typeof window !== 'undefined') {
	      window.addEventListener('resize', this.handleResize);
	    }
	    this.setState({ sideContainerHeight: this.getHeight() });
	  };
	
	  ScholarshipsPage.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (typeof window !== 'undefined') {
	      window.removeEventListener('resize', this.handleResize);
	    }
	  };
	
	  ScholarshipsPage.prototype.render = function render() {
	    var _get = (0, _get3.default)(this, 'props.data.allContentfulTuitionScholarshipsPage.edges'),
	        data = _get[0].node;
	
	    return _react2.default.createElement(
	      'div',
	      {
	        style: {
	          background: '#f7f7f7',
	          fontFamily: "'Libre Franklin', 'sans serif'"
	        }
	      },
	      _react2.default.createElement(_reactHelmet2.default, {
	        title: 'IMRD - Tuition & Scholarships',
	        meta: [{ name: 'description', content: 'tuition and scholarships' }, {
	          name: 'keywords',
	          content: 'IMRD, UGent, tuition, scholarships'.concat(data.scholarships.map(function (_ref) {
	            var name = _ref.name;
	            return ', ' + name;
	          }))
	        }]
	      }),
	      _react2.default.createElement(
	        _mediaQueries.Desktop,
	        null,
	        _react2.default.createElement(DesktopScholarshipsPage, { data: _extends({}, data, this.state) })
	      ),
	      _react2.default.createElement(
	        _mediaQueries.Tablet,
	        null,
	        _react2.default.createElement(TabletScholarshipsPage, { data: data })
	      ),
	      _react2.default.createElement(
	        _mediaQueries.Mobile,
	        null,
	        _react2.default.createElement(MobileScholarshipsPage, { data: data })
	      )
	    );
	  };
	
	  return ScholarshipsPage;
	}(_react.Component);
	
	exports.default = ScholarshipsPage;
	
	
	var DefaultScholarshipsPage = function DefaultScholarshipsPage(_ref2) {
	  var data = _ref2.data;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_infoBlock2.default, {
	      title: data.title,
	      bigTitle: true,
	      text: data.intro.internal.content
	    }),
	    _react2.default.createElement(
	      'div',
	      {
	        style: {
	          display: 'flex',
	          padding: '1rem 0',
	          marginLeft: '',
	          margin: '2.5rem 0 2.5rem'
	        }
	      },
	      _react2.default.createElement(_angleBracketButton2.default, {
	        text: 'Our programme',
	        link: '/programme',
	        hasCaret: false,
	        style: {
	          background: '#8CBD8C'
	        }
	      }),
	      _react2.default.createElement(_angleBracketButton2.default, {
	        text: 'IMRD Administration',
	        link: '/contact',
	        style: {
	          width: '250px',
	          marginLeft: '2rem'
	        }
	      })
	    ),
	    _react2.default.createElement(_title2.default, { style: { fontSize: '16px' }, title: 'Tuition' }),
	    _react2.default.createElement(_infoBlock2.default, { text: data.aboutTuitionFees.internal.content })
	  );
	};
	
	var DesktopScholarshipsPage = function DesktopScholarshipsPage(_ref3) {
	  var data = _ref3.data;
	  return _react2.default.createElement(
	    'div',
	    {
	      style: {
	        display: 'flex',
	        flexDirection: 'row'
	      }
	    },
	    _react2.default.createElement(
	      _sideContainer2.default,
	      {
	        minusHeight: 2.5 * 18,
	        style: {
	          padding: '2rem 17.5vw 2rem 5rem',
	          width: '67vw'
	        }
	      },
	      _react2.default.createElement(DefaultScholarshipsPage, { data: data })
	    ),
	    _react2.default.createElement(
	      'div',
	      {
	        style: {
	          width: '33vw',
	          background: '#8CBD8C'
	        }
	      },
	      _react2.default.createElement(
	        'div',
	        {
	          className: 'scrollable',
	          style: {
	            maxHeight: data.sideContainerHeight,
	            padding: data.isNarrowDesktop ? '2rem 1rem 1rem' : '2rem 2rem 1rem'
	          },
	          hidden: data.sideContainerHeight === 0
	        },
	        _react2.default.createElement(_infoBlock2.default, {
	          title: 'IMRD Scholarships',
	          style: { paddingBottom: '1rem' }
	        }),
	        data.scholarships.map(function (_ref4, i) {
	          var image = _ref4.image,
	              url = _ref4.url,
	              name = _ref4.name,
	              text = _ref4.text;
	          return _react2.default.createElement(
	            'div',
	            { style: { marginBottom: '0.5rem', width: '100%' }, key: i },
	            _react2.default.createElement(_graphicCard2.default, {
	              route: url,
	              title: name,
	              text: text.internal.content,
	              style: {
	                lineHeight: '1.25',
	                fontSize: '13px',
	                padding: ' 1.5rem'
	              },
	              scale: false,
	              image: image,
	              imageStyle: {
	                width: '80%',
	                height: 'auto'
	              }
	            })
	          );
	        })
	      )
	    )
	  );
	};
	var TabletScholarshipsPage = function TabletScholarshipsPage(_ref5) {
	  var data = _ref5.data;
	  return _react2.default.createElement(
	    'div',
	    {
	      style: {
	        padding: '2rem 4rem 0'
	      }
	    },
	    _react2.default.createElement(DefaultScholarshipsPage, { data: data }),
	    _react2.default.createElement(
	      'div',
	      {
	        style: {
	          background: 'linear-gradient(to bottom, #f7f7f7, #f7f7f7 2.5rem, #8CBD8C 2.5rem, #8CBD8C)',
	          padding: '1rem 4rem 2rem',
	          margin: '2rem -4rem 0'
	        }
	      },
	      _react2.default.createElement(
	        _collapsable2.default,
	        { text: 'View our scholarships' },
	        _react2.default.createElement(
	          'div',
	          null,
	          data.scholarships.map(function (_ref6, i) {
	            var image = _ref6.image,
	                url = _ref6.url,
	                name = _ref6.name,
	                text = _ref6.text;
	            return _react2.default.createElement(
	              'div',
	              { style: { marginBottom: '0.5rem' }, key: i },
	              _react2.default.createElement(_graphicCard2.default, {
	                route: url,
	                title: name,
	                text: text.internal.content,
	                style: {
	                  fontSize: '14px',
	                  padding: ' 1.5rem'
	                },
	                image: image,
	                imageStyle: {
	                  width: '25vw',
	                  marginTop: '1rem',
	                  height: 'auto'
	                }
	              })
	            );
	          })
	        )
	      )
	    )
	  );
	};
	
	var MobileScholarshipsPage = function MobileScholarshipsPage(_ref7) {
	  var data = _ref7.data;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_infoBlock2.default, {
	      style: {
	        padding: '1rem 2rem 3rem'
	      },
	      title: data.title,
	      text: data.intro.internal.content
	    }),
	    _react2.default.createElement(_infoBlock2.default, {
	      text: data.aboutTuitionFees.internal.content,
	      style: { background: '#8CBD8C', padding: '1rem 2rem', margin: 0 }
	    }),
	    _react2.default.createElement(
	      'div',
	      {
	        style: {
	          marginTop: '-1px',
	          background: 'linear-gradient(to bottom, #8CBD8C, #8CBD8C 2.5rem, #f7f7f7 2.5rem, #f7f7f7)',
	          padding: '1rem'
	        }
	      },
	      _react2.default.createElement(
	        _collapsable2.default,
	        { text: 'View our scholarships' },
	        _react2.default.createElement(
	          'div',
	          null,
	          data.scholarships.map(function (_ref8, i) {
	            var image = _ref8.image,
	                url = _ref8.url,
	                name = _ref8.name,
	                text = _ref8.text;
	            return _react2.default.createElement(
	              'div',
	              { style: { marginBottom: '0.5rem' }, key: i },
	              _react2.default.createElement(_graphicCard2.default, {
	                route: url,
	                title: name,
	                text: text.internal.content,
	                image: image,
	                imageStyle: {
	                  width: '80%',
	                  height: 'auto'
	                }
	              })
	            );
	          })
	        )
	      ),
	      _react2.default.createElement(_angleBracketButton2.default, {
	        text: 'Our programme',
	        link: '/programme',
	        style: {
	          marginTop: '2rem',
	          marginBottom: '0.5rem',
	          width: 'calc(100vw - 2rem)'
	        }
	      }),
	      _react2.default.createElement(_angleBracketButton2.default, {
	        text: 'Contact',
	        link: '/contact',
	        style: {
	          marginBottom: '0.5rem',
	          width: 'calc(100vw - 2rem)'
	        }
	      })
	    )
	  );
	};
	
	var TuitionAndScholarshipsQuery = exports.TuitionAndScholarshipsQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-tuition-and-scholarships-js-b6497a36e880c2202433.js